var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('export-csv',{attrs:{"jsonData":_vm.items,"reportfields":_vm.json_fields,"sorting":this.sorting,"filename":_vm.filename}},[_vm._v(_vm._s(_vm.$t("GENERAL.EXPORT_CSV")))])
}
var staticRenderFns = []

export { render, staticRenderFns }